export function getQueryString(name: string): string | null {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const splistList = window.location.href.split("?", 2);
    if (splistList.length !== 2) {
        return null;
    }
    const r = splistList[1].match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    }
    return null;
}